export const getAppLicense = `
id
sk
name
idInc
appKey
appSecret
workspaceId
workspace {
  id
  sk
  name
}
resource {
  id
  sk
  name
  config
  workspaceId
}
isDisabled
createdAt
updatedAt
`;

export const listAppLicenses = `
items {
  ${getAppLicense}
}
nextToken  
`;

export const searchApps = `
items {
    id
    idInc
    idVendor
    sk
    type
    version
    bankId
    name
    description
    schemaVersion
    createdAt
    updatedAt
    workspaceId
    appId
    appKey
    appSecret
    resource {
      id
      sk
      name
      description
      workspaceId
    }
    __typename
  }
  nextToken
} 
`;

export const listAppUsers = `
items {
  id
  sk
  name
  user {
    id
    sk
    firstName
    lastName
    email
    avatarHash
  }
}
nextToken
total
__typename
`;
